module.exports = __webpack_public_path__ + "static/media/123.39f83034.mp4";